import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { RefreshCw, X } from 'lucide-react';

interface PWAUpdatePromptProps {
  updateAvailable: boolean;
  onUpdate: () => void;
}

export function PWAUpdatePrompt({ updateAvailable, onUpdate }: PWAUpdatePromptProps) {
  const [dismissed, setDismissed] = useState(false);

  // Reset dismissed state when update becomes available
  useEffect(() => {
    if (updateAvailable) {
      setDismissed(false);
    }
  }, [updateAvailable]);

  if (!updateAvailable || dismissed) return null;

  return (
    <div className="fixed bottom-16 md:bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-80 z-50 animate-slide-up">
      <div className="bg-card border border-border rounded-xl shadow-lg p-4">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
            <RefreshCw className="w-5 h-5 text-primary" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-medium text-foreground text-sm">Update Available</h3>
            <p className="text-xs text-muted-foreground mt-0.5">
              A new version of Leka is ready
            </p>
            <div className="flex gap-2 mt-3">
              <Button
                variant="default"
                size="sm"
                onClick={onUpdate}
                className="h-8 px-3 text-xs"
              >
                Update Now
              </Button>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => setDismissed(true)}
                className="h-8 px-3 text-xs"
              >
                Later
              </Button>
            </div>
          </div>
          <button
            onClick={() => setDismissed(true)}
            className="p-1 hover:bg-muted rounded transition-colors"
            aria-label="Dismiss"
          >
            <X className="w-4 h-4 text-muted-foreground" />
          </button>
        </div>
      </div>
    </div>
  );
}
